import JSZip from 'jszip';
import axiosInstance from './axiosInstance';
import { saveBlob } from './tvecDownload';

export const DOCUMENTS_API = '/admin/tvec-documents';
export const MAX_UPLOAD_BYTES = 25 * 1024 * 1024;
export const ACCEPT = '.jpg,.jpeg,.png,.gif,.webp,.pdf,.doc,.docx,.xls,.xlsx';

const KINDS = {
  jpg: 'image', jpeg: 'image', png: 'image', gif: 'image', webp: 'image',
  pdf: 'pdf',
  doc: 'word', docx: 'word',
  xls: 'excel', xlsx: 'excel',
};

export const extOf = (fileName) => {
  const m = /\.([A-Za-z0-9]+)$/.exec(String(fileName || ''));
  return m ? m[1].toLowerCase() : '';
};
export const kindOf = (fileName) => KINDS[extOf(fileName)] || null;
export const stripExt = (fileName) => String(fileName || '').replace(/\.[^.]+$/, '');

// Safe for a file or folder name inside a ZIP / on disk.
export const safeName = (text, fallback = 'file') =>
  String(text || '').replace(/[\\/:*?"<>|]+/g, '-').replace(/\s+/g, ' ').trim().slice(0, 120) || fallback;

export const versionUrl = (versionId, download = false) =>
  `${DOCUMENTS_API}/versions/${versionId}/file${download ? '?download=1' : ''}`;

// Files are only served to signed-in users, so they are fetched with the API key.
export async function fetchVersionBlob(versionId) {
  const res = await axiosInstance.get(versionUrl(versionId), { responseType: 'blob' });
  return res.data;
}

export async function downloadVersion(version, fileName) {
  saveBlob(await fetchVersionBlob(version.id), fileName || version.originalName);
}

// Puts files in one folder inside a ZIP; entries = [{ path, versionId }].
export async function downloadZip(zipName, folder, entries, onProgress) {
  const zip = new JSZip();
  const dir = zip.folder(safeName(folder, 'Documents'));
  const used = new Set();
  let done = 0;
  for (const entry of entries) {
    let path = safeName(entry.path);
    // Two documents can share a name; keep both.
    if (used.has(path.toLowerCase())) {
      const dot = path.lastIndexOf('.');
      const base = dot > 0 ? path.slice(0, dot) : path;
      const ext = dot > 0 ? path.slice(dot) : '';
      let n = 2;
      while (used.has(`${base} (${n})${ext}`.toLowerCase())) n += 1;
      path = `${base} (${n})${ext}`;
    }
    used.add(path.toLowerCase());
    dir.file(path, await fetchVersionBlob(entry.versionId));
    done += 1;
    if (onProgress) onProgress(done, entries.length);
  }
  saveBlob(await zip.generateAsync({ type: 'blob', compression: 'STORE' }), `${safeName(zipName, 'Documents')}.zip`);
}
